import type { PageData } from "./api";
export type DashboardDataPayload = {
  rows?: Record<string, unknown>[];
  columns?: Record<string, unknown>[];
  sections_enabled?: Record<string, boolean>;
  total_rows?: number;
  offset?: number;
  limit?: number;
  has_more?: boolean;
  summary?: {
    total_sites?: number;
    online?: number;
    offline?: number;
    battery_offline?: number;
    cabinet_offline?: number;
    dg_offline?: number;
    solar_offline?: number;
    io_card_offline?: number;
    sections_enabled?: Record<string, boolean>;
    alarm_types?: Array<{ id?: string; name?: string; count?: number }>;
  };
};
type Timed<T> = { value: T; at: number };
const pageCache = new Map<string, Timed<PageData>>();
let dashboardTimed: Timed<DashboardDataPayload> | undefined;
function parseTtlMs(): number {
  const raw = import.meta.env.VITE_SPA_CACHE_TTL_MS as string | undefined;
  const n = raw != null && String(raw).trim() !== "" ? Number(raw) : NaN;
  if (Number.isFinite(n) && n >= 0) return n;
  return 180_000;
}
/** Max age before revisiting a route triggers a background refetch. Set `0` to always refetch (only instant paint from cache when re-entering). */
export function spaCacheTtlMs(): number {
  return parseTtlMs();
}
export function spaPageDataCachePeek(pageDataUrl: string): Timed<PageData> | undefined {
  return pageCache.get(pageDataUrl);
}
export function spaPageDataCachePut(pageDataUrl: string, data: PageData): void {
  pageCache.set(pageDataUrl, { value: data, at: Date.now() });
}
export function spaPageDataCacheInvalidate(pageDataUrl: string): void {
  pageCache.delete(pageDataUrl);
}

/** Drop every cached ``/api/spa/page-data`` entry for one SPA route id (any query). */
export function spaPageDataCacheInvalidateByRoute(routeId: string): void {
  const want = String(routeId || "").trim();
  if (!want) return;
  for (const key of Array.from(pageCache.keys())) {
    try {
      const route = new URL(key, "http://local").searchParams.get("route");
      if (route === want) pageCache.delete(key);
    } catch {
      if (key.includes(`route=${encodeURIComponent(want)}`) || key.includes(`route=${want}`)) {
        pageCache.delete(key);
      }
    }
  }
}
export function spaDashboardCachePeek(): Timed<DashboardDataPayload> | undefined {
  return dashboardTimed;
}
export function spaDashboardCachePut(payload: DashboardDataPayload): void {
  dashboardTimed = { value: payload, at: Date.now() };
}
export function spaDashboardCacheInvalidate(): void {
  dashboardTimed = undefined;
}
export function spaDataCacheClearAll(): void {
  pageCache.clear();
  dashboardTimed = undefined;
}
